import { RestService } from "./RestService";

export class SettingsRestService extends RestService {
  constructor() {
    super("/api/v1/settings");
  }
}
